import styled, { css } from 'styled-components'

export const Wrapper = styled.main`
  ${({ theme }) => css`
    .slick-track,
    .slick-list {
      display: flex;
      margin-left: -${theme.spacings.small};
    }
    .slick-slide > div {
      margin: 0 ${theme.spacings.medium};
      flex: 1 0 auto;
      height: 100%;
    }
    .slick-list {
      margin: 0 -${theme.spacings.xxsmall};
    }

    .slick-dots {
      display: flex !important;
      justify-content: center;
      margin-top: 3rem;
      margin-bottom: 2.5rem;
      min-height: 4.5rem;

      li {
        margin: 0 0.7rem;

        list-style: none;

        button {
          height: 1.8rem;
          width: 1.8rem;
          border-radius: 5rem;
          background-color: #e1e1e1;
          border: none;
          font-size: 0;
          transition: 0.3s;
        }

        &.slick-active {
          button {
            height: 4rem;
            width: 1.5rem;
            background-color: ${theme.colors.darkPink};
            transition: 0.3s;
          }
        }

        &::marker {
          content: none;
        }
      }
    }
  `}
`
